import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapNodeToApiNodeDto = (values: ICreateNodeForm): IPostNewNode | {} => {
  const dataMapping: IPostNewNode = {
      description: values.description,    
      modelID: +values.modelID,
      unitID: +values.unitID,
      hostName: values.hostName,
      x25NodeAddress: values.x25NodeAddress,
      filepath: values.filepath,
      x25NodeNumber: values.x25NodeNumber, 
  }
  
  return dataMapping;
}

export const createNode = ( {data} : {data: ICreateNodeForm }): Promise<string> => {
  const store = mapNodeToApiNodeDto(data);
  return axiosDefaultApi.post(`/api/Nodes/InsertNode`, store);
};

type QueryFnType = typeof createNode;

type UseCreateNodeOptions = {
  data: IPostNewNode | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateNode = ({ config }: UseCreateNodeOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Κόμβου.`, 500);
      console.error('Couldnt create new store', error);
      setIsNotificationVisible(true)
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllNodes"])
      addNotification(`Ο Κόμβος Δημιουργήθηκε.`, 200);
      setIsNotificationVisible(true)
    },
    ...config,
    mutationFn: createNode,
  })
}